export default {
  googleUserData: {},
  facebookUserData: {},
  linkedinUserData: {},
};
